varying vec3 vPosition;

void main()
{
    float height = vPosition.y/2.25;
    gl_FragColor = vec4(height, height, height, 1.);
}
